let navItems = document.querySelector(".header__inline-menu").querySelectorAll("details");
console.log("navItems",navItems);
navItems.forEach(item => {
    item.addEventListener("mouseover", function() {
      item.setAttribute("open", true);
      item.querySelector("ul li").addEventListener("mouseleave", function() {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", function() {
      item.removeAttribute("open");
    });
  });
});

function pageRedirect() {
  window.location.replace("/cart");
}      
$(document).on('click','.spf-product__form-btn-addtocart', function() {
  setTimeout("pageRedirect()", 1000);
});